import { render, staticRenderFns } from "./chat-agendamento-pendencia.vue?vue&type=template&id=29a0a962&scoped=true"
import script from "./chat-agendamento-pendencia.ts?vue&type=script&lang=ts&external"
export * from "./chat-agendamento-pendencia.ts?vue&type=script&lang=ts&external"
import style0 from "./chat-agendamento-pendencia.scss?vue&type=style&index=0&id=29a0a962&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29a0a962",
  null
  
)

export default component.exports